import React from 'react';
import styled from 'styled-components';
import { getLicenceSelectorSoftwaresHardwareToSoftware } from '../../screens/software_selection_screen/ducks';
import { closeModal, openModal } from '../ducks';
import { connect } from 'react-redux';
import SoftwareSelectionScreenContent from '../../../components/software_licence/software_selection_screen_content';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  position: relative;
  padding: 20px 16px 0px 16px;
  overflow-y: auto;
`;

class SoftwareSelectionScreen extends React.Component {

  static propTypes = {
    setSoftwareSelection: PropTypes.func.isRequired,
    softwaresToShow: PropTypes.array
  }

  constructor(props) {
    super(props);
    this.state = {
      softwareGroups: [],
      filters: [],
      softwaresLoading: false,
    };
  }

  processDisplayableSoftwareGroups = (softwareGroups) => {
    const result = [];
    for (const softwareGroup of softwareGroups) {
      softwareGroup.softwares = softwareGroup.softwares.filter(soft => {
        if (this.props.softwaresToShow != null) {
          return this.props.softwaresToShow.includes(soft.key);
        }

        return true;
      });

      if (softwareGroup.softwares.length > 0) {
        result.push(softwareGroup);
      }
    }

    return result;
  }

  processDisplayableFilters = (filters) => {
    return filters.filter((filterItem) => {
      if (this.props.softwaresToShow != null) {
        return this.props.softwaresToShow.includes(filterItem.softwareKey);
      }
      return true;
    });
  }

  componentDidMount = () => {
    this._isMounted = true;
    this.getLicenceSelectorSoftwares((softwareGroups, filters) => {
      this.updateStateIfMounted({
        softwareGroups: this.processDisplayableSoftwareGroups(softwareGroups),
        filters: this.processDisplayableFilters(filters)
      });
    });
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  getLicenceSelectorSoftwares = (successCallback) => {
    this.updateStateIfMounted({softwaresLoading: true});
    this.props.getLicenceSelectorSoftwares().then((response) => {
      const softwareGroups = response.softwareGroups;
      successCallback(softwareGroups, response.filters);
    }).finally(() => {
      this.updateStateIfMounted({softwaresLoading: false});
    });
  }

  render() {
    return (
      <Container>
        <SoftwareSelectionScreenContent
          softwareGroups={this.state.softwareGroups}
          filters={this.state.filters}
          softwaresLoading={this.state.softwaresLoading}
          setSoftwareSelection={(softwareSelection) => {
            this.props.setSoftwareSelection(softwareSelection);
          }}
          isSaving={this.props.configurationSaver.isSaving}
        >
        </SoftwareSelectionScreenContent>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal()),
    getLicenceSelectorSoftwares: () => dispatch(getLicenceSelectorSoftwaresHardwareToSoftware()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SoftwareSelectionScreen);
